export class Player {
    id: string;
    firstName: string;
    lastName: string;
}